import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const RightimgLeftContent = ({data})=>{
    
    return(

        <> 
        
        <Container className="my-3">
            
        <Row id="borderForMobileOrange" >
            
            <Col md={5} className="rounded-5 bgeYantraOrange py-4 px-4 border-0" id="contentMobileBorder" style={{backgroundImage:'url(./assests/images/internalpages/circles.svg)',
                    backgroundPosition: 'right bottom',
                    backgroundSize: 'auto',
                    backgroundRepeat: 'no-repeat',
            }}>

                <h2 className="fs-48 fs-m-big text-white">{data.rightHeading}</h2>
                <p className="fst-italic fw-normal fw-md-normal fs-20 fs-m-subHeading text-white">{data.rightSmallpara}</p>
                <p className="fs-6 fs-md-5 fw-lighter text-white">
                    {data.rightParagraph}
                </p>

                
                    <Link className="text-white text-decoration-none" to={data.rightRedirectUrl}>
                        <Button id="btnCTA" className="fw-light rounded-5 px-5">
                        Learn More
                        </Button>
                        </Link>
                

                
            </Col>
            <Col md={7} className="p-0 m-0">
                <img className="rounded-5 img-fluid float-end" loading="lazy" src={data.rightImg} id="internalpageBanner"/>
            </Col>
        </Row>
   </Container>
        
        
        </>
    )
}

export default RightimgLeftContent;